import { EMAIL_REGEX } from "src/constants";
import  * as yup from "yup";

export const AddUserSchema = yup.object({
  firstname: yup
    .string()
    .required(`First name is required`)
    .min(3, `At least 3 characters are required in firstname of user`),
  middletname: yup
    .string()
    .min(3, `At least 3 characters are required in middletname of user`),
  lastname: yup
    .string()
    .required(`Last name is required`)
    .min(3, `At least 3 characters are required in lastname of user`),
  email: yup
    .string()
    .email(`Please enter a valid email`)
    .required('Email is required')
    .test('EmailVerification', `Please enter a valid email`, (val) => (EMAIL_REGEX.test(val)), ),
});
